webpackJsonp([1],{

/***/ 194:
/***/ (function(module, exports) {

module.exports = {"COMPRESSED_TYPE_INVALID":"compressed should be a boolean","EC_PRIVATE_KEY_TYPE_INVALID":"private key should be a Buffer","EC_PRIVATE_KEY_LENGTH_INVALID":"private key length is invalid","EC_PRIVATE_KEY_TWEAK_ADD_FAIL":"tweak out of range or resulting private key is invalid","EC_PRIVATE_KEY_TWEAK_MUL_FAIL":"tweak out of range","EC_PRIVATE_KEY_EXPORT_DER_FAIL":"couldn't export to DER format","EC_PRIVATE_KEY_IMPORT_DER_FAIL":"couldn't import from DER format","EC_PUBLIC_KEYS_TYPE_INVALID":"public keys should be an Array","EC_PUBLIC_KEYS_LENGTH_INVALID":"public keys Array should have at least 1 element","EC_PUBLIC_KEY_TYPE_INVALID":"public key should be a Buffer","EC_PUBLIC_KEY_LENGTH_INVALID":"public key length is invalid","EC_PUBLIC_KEY_PARSE_FAIL":"the public key could not be parsed or is invalid","EC_PUBLIC_KEY_CREATE_FAIL":"private was invalid, try again","EC_PUBLIC_KEY_TWEAK_ADD_FAIL":"tweak out of range or resulting public key is invalid","EC_PUBLIC_KEY_TWEAK_MUL_FAIL":"tweak out of range","EC_PUBLIC_KEY_COMBINE_FAIL":"the sum of the public keys is not valid","ECDH_FAIL":"scalar was invalid (zero or overflow)","ECDSA_SIGNATURE_TYPE_INVALID":"signature should be a Buffer","ECDSA_SIGNATURE_LENGTH_INVALID":"signature length is invalid","ECDSA_SIGNATURE_PARSE_FAIL":"couldn't parse signature","ECDSA_SIGNATURE_PARSE_DER_FAIL":"couldn't parse DER signature","ECDSA_SIGNATURE_SERIALIZE_DER_FAIL":"couldn't serialize signature to DER format","ECDSA_SIGN_FAIL":"nonce generation function failed or private key is invalid","ECDSA_RECOVER_FAIL":"couldn't recover public key from signature","MSG32_TYPE_INVALID":"message should be a Buffer","MSG32_LENGTH_INVALID":"message length is invalid","OPTIONS_TYPE_INVALID":"options should be an Object","OPTIONS_DATA_TYPE_INVALID":"options.data should be a Buffer","OPTIONS_DATA_LENGTH_INVALID":"options.data length is invalid","OPTIONS_NONCEFN_TYPE_INVALID":"options.noncefn should be a Function","RECOVERY_ID_TYPE_INVALID":"recovery should be a Number","RECOVERY_ID_VALUE_INVALID":"recovery should have value between -1 and 4","TWEAK_TYPE_INVALID":"tweak should be a Buffer","TWEAK_LENGTH_INVALID":"tweak length is invalid"}

/***/ }),

/***/ 211:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FOO */
/* unused harmony export INIT_NODE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UPDATE_NODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UPDATE_PEERS; });
/* unused harmony export PEERS_STATUS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return UPDATE_BENCHMARKS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return NODE_INFO_VISIBILITY; });
var FOO = 'FOO';
var INIT_NODE = 'INIT_NODE';
var UPDATE_NODE = 'UPDATE_NODE';
var UPDATE_PEERS = 'UPDATE_PEERS';
var PEERS_STATUS = 'PEERS_STATUS';
var UPDATE_BENCHMARKS = 'UPDATE_BENCHMARKS';
var NODE_INFO_VISIBILITY = 'NODE_INFO_VISIBILITY';

/***/ }),

/***/ 221:
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),

/***/ 264:
/***/ (function(module, exports) {

module.exports = {"Addresses":{"Swarm":["/dns4/star-signal.cloud.ipfs.team/wss/p2p-webrtc-star"],"API":"","Gateway":""},"Discovery":{"MDNS":{"Enabled":false,"Interval":10},"webRTCStar":{"Enabled":true}},"Bootstrap":["/dns4/ams-1.bootstrap.libp2p.io/tcp/443/wss/ipfs/QmSoLer265NRgSp2LA3dPaeykiS1J6DifTC88f5uVQKNAd","/dns4/lon-1.bootstrap.libp2p.io/tcp/443/wss/ipfs/QmSoLMeWqB7YGVLJN3pNLQpmmEk35v6wYtsMGLzSr5QBU3","/dns4/sfo-3.bootstrap.libp2p.io/tcp/443/wss/ipfs/QmSoLPppuBtQSGwKDZT2M73ULpjvfd3aZ6ha4oFGL1KrGM","/dns4/sgp-1.bootstrap.libp2p.io/tcp/443/wss/ipfs/QmSoLSafTMBsPKadTEgaXctDQVcqN88CNLHXMkTNwMKPnu","/dns4/nyc-1.bootstrap.libp2p.io/tcp/443/wss/ipfs/QmSoLueR4xBeUbY9WZ9xGUUxunbKWcrNFTDAadQJmocnWm","/dns4/nyc-2.bootstrap.libp2p.io/tcp/443/wss/ipfs/QmSoLV4Bbm51jM9C4gDYZQ9Cy3U6aXMJDAbzgu2fzaDs64","/dns4/wss0.bootstrap.libp2p.io/tcp/443/wss/ipfs/QmZMxNdpMkewiVZLMRxaNxUeZpDUb34pWjZ1kZvsd16Zic","/dns4/wss1.bootstrap.libp2p.io/tcp/443/wss/ipfs/Qmbut9Ywz9YEDrz8ySBSgWyJk41Uvm2QJPhwDJzJyGFsD6"]}

/***/ }),

/***/ 350:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Home__);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Stream benchmarks',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home___default.a
  }]
}));

/***/ }),

/***/ 351:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_dist_logger__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_dist_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuex_dist_logger__);







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */]);

var state = {
  ipfs: {
    // avail values ['starting','running', stopped']
    status: 'stopped',
    addresses: [],
    id: null,
    peers: []
  },
  ipfsConfig: {
    start: false,
    config: {
      Bootstrap: [
      // '/dns4/ams-1.bootstrap.libp2p.io/tcp/443/wss/ipfs/QmSoLer265NRgSp2LA3dPaeykiS1J6DifTC88f5uVQKNAd',
      '/dns4/lon-1.bootstrap.libp2p.io/tcp/443/wss/ipfs/QmSoLMeWqB7YGVLJN3pNLQpmmEk35v6wYtsMGLzSr5QBU3', '/dns4/sfo-3.bootstrap.libp2p.io/tcp/443/wss/ipfs/QmSoLPppuBtQSGwKDZT2M73ULpjvfd3aZ6ha4oFGL1KrGM', '/dns4/sgp-1.bootstrap.libp2p.io/tcp/443/wss/ipfs/QmSoLSafTMBsPKadTEgaXctDQVcqN88CNLHXMkTNwMKPnu', '/dns4/nyc-1.bootstrap.libp2p.io/tcp/443/wss/ipfs/QmSoLueR4xBeUbY9WZ9xGUUxunbKWcrNFTDAadQJmocnWm', '/dns4/nyc-2.bootstrap.libp2p.io/tcp/443/wss/ipfs/QmSoLV4Bbm51jM9C4gDYZQ9Cy3U6aXMJDAbzgu2fzaDs64', '/dns4/wss0.bootstrap.libp2p.io/tcp/443/wss/ipfs/QmZMxNdpMkewiVZLMRxaNxUeZpDUb34pWjZ1kZvsd16Zic', '/dns4/wss1.bootstrap.libp2p.io/tcp/443/wss/ipfs/Qmbut9Ywz9YEDrz8ySBSgWyJk41Uvm2QJPhwDJzJyGFsD6']
    },
    EXPERIMENTAL: { // enable experimental features
      pubsub: true,
      sharding: true, // enable dir sharding
      dht: true // enable KadDHT, currently not interopable with go-ipfs
    }
  },
  benchmarks: [],
  nodeInfoVisible: false
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */].Store({
  state: state,
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_3__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* default */],
  modules: {},
  plugins: [__WEBPACK_IMPORTED_MODULE_5_vuex_dist_logger___default()()],
  strict: true
}));

/***/ }),

/***/ 353:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 354:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(545)
}
var Component = __webpack_require__(88)(
  /* script */
  __webpack_require__(407),
  /* template */
  __webpack_require__(913),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 402:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_default_index_css__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_default_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_default_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(351);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 403:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);

var hrtime = __webpack_require__(216);
var EventEmitter = __webpack_require__(12);

/* harmony default export */ __webpack_exports__["a"] = (function (options) {
  var event = new EventEmitter();
  // const NS_PER_SEC = 1e9
  var started = options.started;
  var intervalTimeout = options.interval || 0.01;

  var metrics = {
    hash: options.hash,
    totalBytes: 0,
    received: 0,
    elapsed: null,
    started: options.startedTimestamp,
    finished: null,
    chunks: [],
    rates: {
      min: 0,
      max: 0,
      avg: 0,
      median: 0
    },
    overallRate: 0
  };
  var interval = setInterval(function () {
    metrics.elapsed = duration(started);
    metrics.overallRate = speed(metrics.received, duration(started));
    metrics.rates = calcRates(metrics.chunks.map(function (chunk) {
      return chunk.rate;
    }));

    event.emit('interval', __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(metrics));
  }, intervalTimeout);

  options.filesStream.on('data', function (file) {
    metrics.totalBytes = file.size;
    if (file.content) {
      file.content.on('data', function (data) {
        // Ignore zero-length chunks, they produce zero min rate
        if (data.length === 0) return;

        metrics.received += data.length;

        var lastHr = metrics.chunks.length > 0 ? metrics.chunks[metrics.chunks.length - 1].hrtime : started;

        // const lastElapsed = duration(lastHr)
        var chunk = {
          time: Date.now(),
          hrtime: hrtime(),
          bytes: data.length,
          elaspedSinceLast: duration(lastHr),
          rate: speed(metrics.received, duration(started))
        };

        metrics.chunks.push(chunk);

        metrics.rates = calcRates(metrics.chunks.map(function (chunk) {
          return chunk.rate;
        }));
        metrics.overallRate = speed(metrics.received, duration(started));

        event.emit('data', __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(metrics));
      });

      file.content.once('end', function (data) {
        clearInterval(interval);

        metrics.rates = calcRates(metrics.chunks.map(function (chunk) {
          return chunk.rate;
        }));
        metrics.finished = Date.now();
        metrics.overallRate = speed(metrics.received, duration(started));

        event.emit('end', __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(metrics));
        event.removeAllListeners();
      });

      file.content.resume();
    }
  });

  options.filesStream.on('end', function () {
    return console.log('Got files info for ', options.hash);
  });
  return event;
});

var duration = function duration(start) {
  var nsPerSec = 1e9;
  var time = hrtime(start);
  // In seconds
  return (time[0] * nsPerSec + time[1]) / nsPerSec;
};

var calcRates = function calcRates(rates) {
  rates.sort(function (a, b) {
    if (a > b) return 1;else if (a === b) return 0;
    return -1;
  });
  var min = rates[0] || 0;
  var max = rates[rates.length - 1] || 0;
  var avg = rates.reduce(function (p, c) {
    return p + c;
  }, 0) / rates.length || 0;

  var middle = Math.floor(rates.length / 2);
  var isEven = rates.length % 2 === 0;
  var median = isEven ? (rates[middle] + rates[middle - 1]) / 2 || 0 : rates[middle] || 0;

  return {
    min: min,
    max: max,
    median: median,
    avg: avg
  };
};

var speed = function speed(size, time) {
  if (size === 0) return 0;
  return Math.round(size / (time || 1));
};

/***/ }),

/***/ 404:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "initNode", function() { return initNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "openNodeInfo", function() { return openNodeInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "closeNodeInfo", function() { return closeNodeInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "startNode", function() { return startNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "stopNode", function() { return stopNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "monitorPeers", function() { return monitorPeers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFile", function() { return getFile; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ipfs__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ipfs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ipfs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_browser_process_hrtime__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_browser_process_hrtime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_browser_process_hrtime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plugins_IpfsStreamBench__ = __webpack_require__(403);
var _this = this;







var PEER_UPDATE_INTERVAL = 3000;

var initNode = function initNode(_ref, params) {
  var commit = _ref.commit,
      getters = _ref.getters;

  if (_this.node) return console.warn('initNode: Is already initialized ');
  var options = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.assign({
    repo: 'ipfs-' + Math.random()
  }, getters.ipfs.config);
  _this.node = new __WEBPACK_IMPORTED_MODULE_1_ipfs___default.a(options);
  _this.monitorPeers({ commit: commit, getters: getters }, params);
};

var openNodeInfo = function openNodeInfo(_ref2, params) {
  var commit = _ref2.commit,
      getters = _ref2.getters;

  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["d" /* NODE_INFO_VISIBILITY */], true);
};

var closeNodeInfo = function closeNodeInfo(_ref3, params) {
  var commit = _ref3.commit,
      getters = _ref3.getters;

  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["d" /* NODE_INFO_VISIBILITY */], false);
};

var startNode = function startNode(_ref4, params) {
  var commit = _ref4.commit;

  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["a" /* UPDATE_NODE */], { status: 'starting' });
  _this.node.start(function () {
    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["a" /* UPDATE_NODE */], { status: 'running' });
    _this.node.id().then(function (info) {
      commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["a" /* UPDATE_NODE */], {
        id: info.id,
        addresses: info.addresses
      });
    });
  });
};

var stopNode = function stopNode(_ref5, params) {
  var commit = _ref5.commit;

  if (!_this.node) return;
  _this.node.stop(function () {
    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["a" /* UPDATE_NODE */], {
      status: 'stopped'
    });
    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["b" /* UPDATE_PEERS */], []);
  });
};

var monitorPeers = function monitorPeers(_ref6, params) {
  var getters = _ref6.getters,
      commit = _ref6.commit;

  if (getters.ipfs.state.status === 'stopped' || !_this.node || !_this.node.isOnline()) {} else {
    _this.node.swarm.peers({
      verbose: true
    }, function (err, peers) {
      if (err) console.warn('swarm.peers: Error ', err);
      var filtered = peers.filter(function (p) {
        return p.addr;
      });
      commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["b" /* UPDATE_PEERS */], filtered.map(function (peer) {
        return {
          addr: peer.addr.toString(),
          id: peer.peer.id.toB58String()
        };
      }));
    });
  }
  setTimeout(function () {
    monitorPeers({ getters: getters, commit: commit }, params);
  }, PEER_UPDATE_INTERVAL);
};

var getFile = function getFile(_ref7, hash) {
  var commit = _ref7.commit;

  if (!hash) {
    return console.log('getFile: no multihash was inserted');
  }

  var started = __WEBPACK_IMPORTED_MODULE_3_browser_process_hrtime___default()();
  var startedTimestamp = Date.now();

  _this.node.files.get(hash, function (err, filesStream) {
    if (err) {
      return console.log('ipfs.files.get: Error ', err);
    }
    //
    // Calculate Stream benchmarks
    var bench = new __WEBPACK_IMPORTED_MODULE_4__plugins_IpfsStreamBench__["a" /* default */]({
      started: started,
      startedTimestamp: startedTimestamp,
      filesStream: filesStream,
      hash: hash,
      interval: 1000,
      timeout: 20000
    });

    bench.on('data', function (report) {
      return commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* UPDATE_BENCHMARKS */], report);
    });
    bench.on('interval', function (report) {
      return commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* UPDATE_BENCHMARKS */], report);
    });
    bench.on('end', function (report) {
      return commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* UPDATE_BENCHMARKS */], report);
    });
  });
};

/***/ }),

/***/ 405:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ipfs", function() { return ipfs; });
var ipfs = function ipfs(state) {
  return {
    state: state.ipfs,
    config: state.ipfsConfig
  };
};

/***/ }),

/***/ 406:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);


var _types$UPDATE_NODE$ty;




/* harmony default export */ __webpack_exports__["a"] = (_types$UPDATE_NODE$ty = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_NODE$ty, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* UPDATE_NODE */], function (state, data) {
  var allowedValues = ['status', 'addresses', 'id'];
  __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.extend(state.ipfs, __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.pick(data, allowedValues));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_NODE$ty, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* UPDATE_PEERS */], function (state, peers) {
  // Reset peers array
  state.ipfs.peers = [];
  if (state.ipfs.status === 'stopped') return;
  peers.forEach(function (peer) {
    return state.ipfs.peers.push(peer);
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_NODE$ty, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* UPDATE_BENCHMARKS */], function (state, report) {
  var hash = report.hash;
  var file = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(state.benchmarks, { hash: hash });
  if (!file) return state.benchmarks.push(report);
  __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.extend(file, report);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_NODE$ty, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* NODE_INFO_VISIBILITY */], function (state, status) {
  state.nodeInfoVisible = status;
}), _types$UPDATE_NODE$ty);

/***/ }),

/***/ 407:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(89);

//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  mounted: function mounted() {
    this.initNode();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['initNode']))
});

/***/ }),

/***/ 408:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Stream__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Stream___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Stream__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TopNav__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TopNav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__TopNav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NodeInfo__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NodeInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__NodeInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(89);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Stream: __WEBPACK_IMPORTED_MODULE_1__Stream___default.a, TopNav: __WEBPACK_IMPORTED_MODULE_2__TopNav___default.a, NodeInfo: __WEBPACK_IMPORTED_MODULE_3__NodeInfo___default.a },
  data: function data() {
    return {
      activeTab: 'first'
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapActions */])(['getFile', 'startNode']), {
    getBenchmarkByHash: function getBenchmarkByHash(hash) {
      return this.benchmarks.find(function (bench) {
        return bench.hash === hash;
      });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapState */])({
    benchmarks: function benchmarks(state) {
      return state.benchmarks;
    },
    status: function status(state) {
      return state.ipfs.status;
    },
    peers: function peers(state) {
      return state.ipfs.peers;
    }
  }))
});

/***/ }),

/***/ 409:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(89);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])({
    status: function status(state) {
      return state.ipfs.status;
    },
    node: function node(state) {
      return state.ipfs;
    },
    peersStatus: function peersStatus(state) {
      return state.peersStatus;
    },
    visible: function visible(state) {
      return state.nodeInfoVisible;
    }
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['startNode', 'stopNode', 'closeNodeInfo']))
});

/***/ }),

/***/ 410:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pretty_bytes__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pretty_bytes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_pretty_bytes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_pretty_time__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_pretty_time___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_pretty_time__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pretty_seconds__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pretty_seconds___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pretty_seconds__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import StreamStatus from './StreamStatus'




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    nodeStatus: {
      type: String
    },
    btnText: {
      default: 'Run'
    },
    hash: {
      type: String
    },
    benchmarks: {
      type: Object
    },
    peers: {
      type: Array
    }
  },
  data: function data() {
    return {
      fileHash: this.hash,
      loading: false
    };
  },

  methods: {
    prettyBytes: __WEBPACK_IMPORTED_MODULE_0_pretty_bytes___default.a,
    prettyTime: __WEBPACK_IMPORTED_MODULE_1_pretty_time___default.a,
    start: function start(event) {
      if (this.nodeStatus !== 'running') {
        this.$message({
          message: 'Your node is not runnng. Start your node first',
          type: 'warning'
        });
        return;
      }
      if (this.peers.length === 0) {
        this.$message({
          message: 'No peers connected yet. Wait for a few seconds and try again',
          type: 'warning'
        });
        return;
      }
      this.$emit('submit', this.fileHash);
      this.loading = true;
    },

    percentage: function percentage(from, to) {
      return from / to * 100;
    },
    downloadPercentage: function downloadPercentage() {
      if (!this.benchmarks || !this.benchmarks.received) return '0';
      var percentage = this.percentage(this.benchmarks.received, this.benchmarks.totalBytes);
      return percentage.toFixed(0);
    },
    received: function received() {
      return this.benchmarks ? __WEBPACK_IMPORTED_MODULE_0_pretty_bytes___default()(this.benchmarks.received) : 0;
    },
    total: function total() {
      return this.benchmarks ? __WEBPACK_IMPORTED_MODULE_0_pretty_bytes___default()(this.benchmarks.totalBytes) : 0;
    },
    elapsed: function elapsed() {
      if (!this.benchmarks) return __WEBPACK_IMPORTED_MODULE_2_pretty_seconds___default()(0);
      return __WEBPACK_IMPORTED_MODULE_2_pretty_seconds___default()(this.benchmarks.elapsed);
    },
    rate: function rate() {
      return this.benchmarks ? __WEBPACK_IMPORTED_MODULE_0_pretty_bytes___default()(this.benchmarks.overallRate) : __WEBPACK_IMPORTED_MODULE_0_pretty_bytes___default()(0);
    }
  },
  watch: {
    'benchmarks.finished': function benchmarksFinished(finished) {
      if (finished) this.loading = false;
    }
  }
});

/***/ }),

/***/ 411:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(89);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])({
    status: function status(state) {
      return state.ipfs.status;
    },
    node: function node(state) {
      return state.ipfs;
    }
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['startNode', 'stopNode', 'openNodeInfo']))
});

/***/ }),

/***/ 491:
/***/ (function(module, exports) {

module.exports = {"sha1":{"securityStrength":128,"outlen":160,"seedlen":440},"sha224":{"securityStrength":192,"outlen":224,"seedlen":440},"sha256":{"securityStrength":256,"outlen":256,"seedlen":440},"sha384":{"securityStrength":256,"outlen":384,"seedlen":888},"sha512":{"securityStrength":256,"outlen":512,"seedlen":888}}

/***/ }),

/***/ 523:
/***/ (function(module, exports) {

module.exports = {"_from":"elliptic@^6.2.3","_id":"elliptic@6.4.0","_inBundle":false,"_integrity":"sha1-ysmvh2LIWDYYcAPI3+GT5eLq5d8=","_location":"/elliptic","_phantomChildren":{},"_requested":{"type":"range","registry":true,"raw":"elliptic@^6.2.3","name":"elliptic","escapedName":"elliptic","rawSpec":"^6.2.3","saveSpec":null,"fetchSpec":"^6.2.3"},"_requiredBy":["/browserify-sign","/create-ecdh","/secp256k1"],"_resolved":"https://registry.npmjs.org/elliptic/-/elliptic-6.4.0.tgz","_shasum":"cac9af8762c85836187003c8dfe193e5e2eae5df","_spec":"elliptic@^6.2.3","_where":"/Users/imp/code/benchmark.js.ipfs.io/node_modules/secp256k1","author":{"name":"Fedor Indutny","email":"fedor@indutny.com"},"bugs":{"url":"https://github.com/indutny/elliptic/issues"},"bundleDependencies":false,"dependencies":{"bn.js":"^4.4.0","brorand":"^1.0.1","hash.js":"^1.0.0","hmac-drbg":"^1.0.0","inherits":"^2.0.1","minimalistic-assert":"^1.0.0","minimalistic-crypto-utils":"^1.0.0"},"deprecated":false,"description":"EC cryptography","devDependencies":{"brfs":"^1.4.3","coveralls":"^2.11.3","grunt":"^0.4.5","grunt-browserify":"^5.0.0","grunt-cli":"^1.2.0","grunt-contrib-connect":"^1.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^1.0.1","grunt-mocha-istanbul":"^3.0.1","grunt-saucelabs":"^8.6.2","istanbul":"^0.4.2","jscs":"^2.9.0","jshint":"^2.6.0","mocha":"^2.1.0"},"files":["lib"],"homepage":"https://github.com/indutny/elliptic","keywords":["EC","Elliptic","curve","Cryptography"],"license":"MIT","main":"lib/elliptic.js","name":"elliptic","repository":{"type":"git","url":"git+ssh://git@github.com/indutny/elliptic.git"},"scripts":{"jscs":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","jshint":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","lint":"npm run jscs && npm run jshint","test":"npm run lint && npm run unit","unit":"istanbul test _mocha --reporter=spec test/index.js","version":"grunt dist && git add dist/"},"version":"6.4.0"}

/***/ }),

/***/ 535:
/***/ (function(module, exports) {

module.exports = {"genesisGasLimit":{"v":5000,"d":"Gas limit of the Genesis block."},"genesisDifficulty":{"v":17179869184,"d":"Difficulty of the Genesis block."},"genesisNonce":{"v":"0x0000000000000042","d":"the geneis nonce"},"genesisExtraData":{"v":"0x11bbe8db4e347b4e8c937c1c8370e4b5ed33adb3db69cbdb7a38e1e50b1b82fa","d":"extra data "},"genesisHash":{"v":"0xd4e56740f876aef8c010b86a40d5f56745a118d0906a34e69aec8c0db1cb8fa3","d":"genesis hash"},"genesisStateRoot":{"v":"0xd7f8974fb5ac78d9ac099b9ad5018bedc2ce0a72dad1827a1709da30580f0544","d":"the genesis state root"},"minGasLimit":{"v":5000,"d":"Minimum the gas limit may ever be."},"gasLimitBoundDivisor":{"v":1024,"d":"The bound divisor of the gas limit, used in update calculations."},"minimumDifficulty":{"v":131072,"d":"The minimum that the difficulty may ever be."},"difficultyBoundDivisor":{"v":2048,"d":"The bound divisor of the difficulty, used in the update calculations."},"durationLimit":{"v":13,"d":"The decision boundary on the blocktime duration used to determine whether difficulty should go up or not."},"maximumExtraDataSize":{"v":32,"d":"Maximum size extra data may be after Genesis."},"epochDuration":{"v":30000,"d":"Duration between proof-of-work epochs."},"stackLimit":{"v":1024,"d":"Maximum size of VM stack allowed."},"callCreateDepth":{"v":1024,"d":"Maximum depth of call/create stack."},"tierStepGas":{"v":[0,2,3,5,8,10,20],"d":"Once per operation, for a selection of them."},"expGas":{"v":10,"d":"Once per EXP instuction."},"expByteGas":{"v":50,"d":"Times ceil(log256(exponent)) for the EXP instruction."},"sha3Gas":{"v":30,"d":"Once per SHA3 operation."},"sha3WordGas":{"v":6,"d":"Once per word of the SHA3 operation's data."},"sloadGas":{"v":50,"d":"Once per SLOAD operation."},"sstoreSetGas":{"v":20000,"d":"Once per SSTORE operation if the zeroness changes from zero."},"sstoreResetGas":{"v":5000,"d":"Once per SSTORE operation if the zeroness does not change from zero."},"sstoreRefundGas":{"v":15000,"d":"Once per SSTORE operation if the zeroness changes to zero."},"jumpdestGas":{"v":1,"d":"Refunded gas, once per SSTORE operation if the zeroness changes to zero."},"logGas":{"v":375,"d":"Per LOG* operation."},"logDataGas":{"v":8,"d":"Per byte in a LOG* operation's data."},"logTopicGas":{"v":375,"d":"Multiplied by the * of the LOG*, per LOG transaction. e.g. LOG0 incurs 0 * c_txLogTopicGas, LOG4 incurs 4 * c_txLogTopicGas."},"createGas":{"v":32000,"d":"Once per CREATE operation & contract-creation transaction."},"callGas":{"v":40,"d":"Once per CALL operation & message call transaction."},"callStipend":{"v":2300,"d":"Free gas given at beginning of call."},"callValueTransferGas":{"v":9000,"d":"Paid for CALL when the value transfor is non-zero."},"callNewAccountGas":{"v":25000,"d":"Paid for CALL when the destination address didn't exist prior."},"suicideRefundGas":{"v":24000,"d":"Refunded following a suicide operation."},"memoryGas":{"v":3,"d":"Times the address of the (highest referenced byte in memory + 1). NOTE: referencing happens on read, write and in instructions such as RETURN and CALL."},"quadCoeffDiv":{"v":512,"d":"Divisor for the quadratic particle of the memory cost equation."},"createDataGas":{"v":200,"d":""},"txGas":{"v":21000,"d":"Per transaction. NOTE: Not payable on data of calls between transactions."},"txCreation":{"v":32000,"d":"the cost of creating a contract via tx"},"txDataZeroGas":{"v":4,"d":"Per byte of data attached to a transaction that equals zero. NOTE: Not payable on data of calls between transactions."},"txDataNonZeroGas":{"v":68,"d":"Per byte of data attached to a transaction that is not equal to zero. NOTE: Not payable on data of calls between transactions."},"copyGas":{"v":3,"d":"Multiplied by the number of 32-byte words that are copied (round up) for any *COPY operation and added."},"ecrecoverGas":{"v":3000,"d":""},"sha256Gas":{"v":60,"d":""},"sha256WordGas":{"v":12,"d":""},"ripemd160Gas":{"v":600,"d":""},"ripemd160WordGas":{"v":120,"d":""},"identityGas":{"v":15,"d":""},"identityWordGas":{"v":3,"d":""},"modexpGquaddivisor":{"v":20,"d":"Gquaddivisor from modexp precompile for gas calculation."},"ecAddGas":{"v":500,"d":"Gas costs for curve addition precompile."},"ecMulGas":{"v":40000,"d":"Gas costs for curve multiplication precompile."},"ecPairingGas":{"v":100000,"d":"Base gas costs for curve pairing precompile."},"ecPairingWordGas":{"v":80000,"d":"Gas costs regarding curve pairing precompile input length."},"minerReward":{"v":"3000000000000000000","d":"the amount a miner get rewarded for mining a block"},"homeSteadForkNumber":{"v":1150000,"d":"the block that the Homestead fork started at"},"homesteadRepriceForkNumber":{"v":2463000,"d":"the block that the Homestead Reprice (EIP150) fork started at"},"timebombPeriod":{"v":100000,"d":"Exponential difficulty timebomb period"},"freeBlockPeriod":{"v":2}}

/***/ }),

/***/ 539:
/***/ (function(module, exports) {

module.exports = {"genesisGasLimit":{"v":5000,"d":"Gas limit of the Genesis block."},"genesisDifficulty":{"v":17179869184,"d":"Difficulty of the Genesis block."},"genesisNonce":{"v":"0x0000000000000042","d":"the geneis nonce"},"genesisExtraData":{"v":"0x11bbe8db4e347b4e8c937c1c8370e4b5ed33adb3db69cbdb7a38e1e50b1b82fa","d":"extra data "},"genesisHash":{"v":"0xd4e56740f876aef8c010b86a40d5f56745a118d0906a34e69aec8c0db1cb8fa3","d":"genesis hash"},"genesisStateRoot":{"v":"0xd7f8974fb5ac78d9ac099b9ad5018bedc2ce0a72dad1827a1709da30580f0544","d":"the genesis state root"},"minGasLimit":{"v":5000,"d":"Minimum the gas limit may ever be."},"gasLimitBoundDivisor":{"v":1024,"d":"The bound divisor of the gas limit, used in update calculations."},"minimumDifficulty":{"v":131072,"d":"The minimum that the difficulty may ever be."},"difficultyBoundDivisor":{"v":2048,"d":"The bound divisor of the difficulty, used in the update calculations."},"durationLimit":{"v":13,"d":"The decision boundary on the blocktime duration used to determine whether difficulty should go up or not."},"maximumExtraDataSize":{"v":32,"d":"Maximum size extra data may be after Genesis."},"epochDuration":{"v":30000,"d":"Duration between proof-of-work epochs."},"stackLimit":{"v":1024,"d":"Maximum size of VM stack allowed."},"callCreateDepth":{"v":1024,"d":"Maximum depth of call/create stack."},"tierStepGas":{"v":[0,2,3,5,8,10,20],"d":"Once per operation, for a selection of them."},"expGas":{"v":10,"d":"Once per EXP instuction."},"expByteGas":{"v":10,"d":"Times ceil(log256(exponent)) for the EXP instruction."},"sha3Gas":{"v":30,"d":"Once per SHA3 operation."},"sha3WordGas":{"v":6,"d":"Once per word of the SHA3 operation's data."},"sloadGas":{"v":50,"d":"Once per SLOAD operation."},"sstoreSetGas":{"v":20000,"d":"Once per SSTORE operation if the zeroness changes from zero."},"sstoreResetGas":{"v":5000,"d":"Once per SSTORE operation if the zeroness does not change from zero."},"sstoreRefundGas":{"v":15000,"d":"Once per SSTORE operation if the zeroness changes to zero."},"jumpdestGas":{"v":1,"d":"Refunded gas, once per SSTORE operation if the zeroness changes to zero."},"logGas":{"v":375,"d":"Per LOG* operation."},"logDataGas":{"v":8,"d":"Per byte in a LOG* operation's data."},"logTopicGas":{"v":375,"d":"Multiplied by the * of the LOG*, per LOG transaction. e.g. LOG0 incurs 0 * c_txLogTopicGas, LOG4 incurs 4 * c_txLogTopicGas."},"createGas":{"v":32000,"d":"Once per CREATE operation & contract-creation transaction."},"callGas":{"v":40,"d":"Once per CALL operation & message call transaction."},"callStipend":{"v":2300,"d":"Free gas given at beginning of call."},"callValueTransferGas":{"v":9000,"d":"Paid for CALL when the value transfor is non-zero."},"callNewAccountGas":{"v":25000,"d":"Paid for CALL when the destination address didn't exist prior."},"suicideRefundGas":{"v":24000,"d":"Refunded following a suicide operation."},"memoryGas":{"v":3,"d":"Times the address of the (highest referenced byte in memory + 1). NOTE: referencing happens on read, write and in instructions such as RETURN and CALL."},"quadCoeffDiv":{"v":512,"d":"Divisor for the quadratic particle of the memory cost equation."},"createDataGas":{"v":200,"d":""},"txGas":{"v":21000,"d":"Per transaction. NOTE: Not payable on data of calls between transactions."},"txCreation":{"v":32000,"d":"the cost of creating a contract via tx"},"txDataZeroGas":{"v":4,"d":"Per byte of data attached to a transaction that equals zero. NOTE: Not payable on data of calls between transactions."},"txDataNonZeroGas":{"v":68,"d":"Per byte of data attached to a transaction that is not equal to zero. NOTE: Not payable on data of calls between transactions."},"copyGas":{"v":3,"d":"Multiplied by the number of 32-byte words that are copied (round up) for any *COPY operation and added."},"ecrecoverGas":{"v":3000,"d":""},"sha256Gas":{"v":60,"d":""},"sha256WordGas":{"v":12,"d":""},"ripemd160Gas":{"v":600,"d":""},"ripemd160WordGas":{"v":120,"d":""},"identityGas":{"v":15,"d":""},"identityWordGas":{"v":3,"d":""},"minerReward":{"v":"5000000000000000000","d":"the amount a miner get rewarded for mining a block"},"ommerReward":{"v":"625000000000000000","d":"The amount of wei a miner of an uncle block gets for being inculded in the blockchain"},"niblingReward":{"v":"156250000000000000","d":"the amount a miner gets for inculding a uncle"},"homeSteadForkNumber":{"v":1150000,"d":"the block that the Homestead fork started at"},"homesteadRepriceForkNumber":{"v":2463000,"d":"the block that the Homestead Reprice (EIP150) fork started at"},"timebombPeriod":{"v":100000,"d":"Exponential difficulty timebomb period"},"freeBlockPeriod":{"v":2}}

/***/ }),

/***/ 541:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 542:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 543:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 544:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 545:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 609:
/***/ (function(module, exports) {

module.exports = {"_from":"ipfs@^0.26.0","_id":"ipfs@0.26.0","_inBundle":false,"_integrity":"sha512-0FKFV7oyiIaZVE+PtuxB16Xg76jw+LCXEGWy+BF0QWSdyqqaXpfQvd2XSgAYLSctbOxlMKLJSOJV5Sb32X2QCw==","_location":"/ipfs","_phantomChildren":{},"_requested":{"type":"range","registry":true,"raw":"ipfs@^0.26.0","name":"ipfs","escapedName":"ipfs","rawSpec":"^0.26.0","saveSpec":null,"fetchSpec":"^0.26.0"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/ipfs/-/ipfs-0.26.0.tgz","_shasum":"54335ecdff0e35dedde3a48cd1a9f1c354dca42d","_spec":"ipfs@^0.26.0","_where":"/Users/imp/code/benchmark.js.ipfs.io","author":{"name":"David Dias","email":"daviddias@ipfs.io"},"bin":{"jsipfs":"src/cli/bin.js"},"browser":{"./src/core/components/init-assets.js":false,"./src/core/runtime/config-nodejs.json":"./src/core/runtime/config-browser.json","./src/core/runtime/libp2p-nodejs.js":"./src/core/runtime/libp2p-browser.js","./src/core/runtime/repo-nodejs.js":"./src/core/runtime/repo-browser.js","./test/utils/create-repo-nodejs.js":"./test/utils/create-repo-browser.js","stream":"readable-stream"},"bugs":{"url":"https://github.com/ipfs/js-ipfs/issues"},"bundleDependencies":false,"contributors":[{"name":"Andrew de Andrade","email":"andrew@deandrade.com.br"},{"name":"Bernard Mordan","email":"bernard@tableflip.io"},{"name":"CHEVALAY JOSSELIN","email":"josselin54.chevalay@gmail.com"},{"name":"Caio Gondim","email":"me@caiogondim.com"},{"name":"Christian Couder","email":"chriscool@tuxfamily.org"},{"name":"Daniel J. O'Quinn","email":"danieljoquinn@gmail.com"},{"name":"Daniela Borges Matos de Carvalho","email":"alunassertiva@gmail.com"},{"name":"David Dias","email":"daviddias.p@gmail.com"},{"name":"Dmitriy Ryajov","email":"dryajov@gmail.com"},{"name":"Dzmitry Das","email":"dbachko@gmail.com"},{"name":"Enrico Marino","email":"enrico.marino@email.com"},{"name":"Felix Yan","email":"felixonmars@archlinux.org"},{"name":"Francisco Baio Dias","email":"xicombd@gmail.com"},{"name":"Francisco Baio Dias","email":"francisco@typeform.com"},{"name":"Friedel Ziegelmayer","email":"dignifiedquire@gmail.com"},{"name":"Georgios Rassias","email":"georassias@gmail.com"},{"name":"Greenkeeper","email":"support@greenkeeper.io"},{"name":"Haad","email":"haadcode@users.noreply.github.com"},{"name":"Harsh Vakharia","email":"harshjv@users.noreply.github.com"},{"name":"Henry Rodrick","email":"moshisushi@gmail.com"},{"name":"Johannes Wikner","email":"johannes.wikner@gmail.com"},{"name":"Jon Schlinkert","email":"dev@sellside.com"},{"name":"João Antunes","email":"j.goncalo.antunes@gmail.com"},{"name":"Kevin Wang","email":"kevin@fossa.io"},{"name":"Lars Gierth","email":"larsg@systemli.org"},{"name":"Maciej Krüger","email":"mkg20001@gmail.com"},{"name":"Marius Darila","email":"marius.darila@gmail.com"},{"name":"Michelle Lee","email":"michelle@protocol.ai"},{"name":"Mikeal Rogers","email":"mikeal.rogers@gmail.com"},{"name":"Mithgol","email":"getgit@mithgol.ru"},{"name":"Nuno Nogueira","email":"nunofmn@gmail.com"},{"name":"Oskar Nyberg","email":"oskar@oskarnyberg.com"},{"name":"Pau Ramon Revilla","email":"masylum@gmail.com"},{"name":"Pedro Teixeira","email":"i@pgte.me"},{"name":"RasmusErik Voel Jensen","email":"github@solsort.com"},{"name":"Richard Littauer","email":"richard.littauer@gmail.com"},{"name":"Rod Keys","email":"rod@zokos.com"},{"name":"Sid Harder","email":"sideharder@gmail.com"},{"name":"SidHarder","email":"softwarenavigator@gmail.com"},{"name":"Stephen Whitmore","email":"stephen.whitmore@gmail.com"},{"name":"Stephen Whitmore","email":"noffle@users.noreply.github.com"},{"name":"Terence Pae","email":"terencepae@gmail.com"},{"name":"Uroš Jurglič","email":"jurglic@gmail.com"},{"name":"Xiao Liang","email":"yxliang01@users.noreply.github.com"},{"name":"Yahya","email":"ya7yaz@gmail.com"},{"name":"bitspill","email":"bitspill+github@bitspill.net"},{"name":"haad","email":"haad@headbanggames.com"},{"name":"jbenet","email":"juan@benet.ai"},{"name":"kumavis","email":"kumavis@users.noreply.github.com"},{"name":"nginnever","email":"ginneversource@gmail.com"},{"name":"npmcdn-to-unpkg-bot","email":"npmcdn-to-unpkg-bot@users.noreply.github.com"},{"name":"tcme","email":"hi@this-connect.me"},{"name":"Łukasz Magiera","email":"magik6k@users.noreply.github.com"},{"name":"ᴠɪᴄᴛᴏʀ ʙᴊᴇʟᴋʜᴏʟᴍ","email":"victorbjelkholm@gmail.com"}],"dependencies":{"async":"^2.5.0","bl":"^1.2.1","boom":"^5.2.0","cids":"^0.5.1","debug":"^3.0.1","file-type":"^6.1.0","filesize":"^3.5.10","fsm-event":"^2.1.0","glob":"^7.1.2","hapi":"^16.5.2","hapi-set-header":"^1.0.2","hoek":"^4.2.0","ipfs-api":"^14.3.5","ipfs-bitswap":"~0.17.2","ipfs-block":"~0.6.0","ipfs-block-service":"~0.12.0","ipfs-multipart":"~0.1.0","ipfs-repo":"~0.17.0","ipfs-unixfs":"~0.1.13","ipfs-unixfs-engine":"~0.22.5","ipld-resolver":"~0.13.2","is-ipfs":"^0.3.2","is-stream":"^1.1.0","joi":"^10.6.0","libp2p":"~0.12.4","libp2p-floodsub":"~0.11.1","libp2p-kad-dht":"~0.5.1","libp2p-mdns":"~0.9.1","libp2p-multiplex":"~0.5.0","libp2p-railing":"~0.7.1","libp2p-secio":"~0.8.1","libp2p-tcp":"~0.11.0","libp2p-webrtc-star":"~0.13.2","libp2p-websockets":"~0.10.1","lodash.flatmap":"^4.5.0","lodash.get":"^4.4.2","lodash.sortby":"^4.7.0","lodash.values":"^4.3.0","mafmt":"^3.0.1","mime-types":"^2.1.17","mkdirp":"~0.5.1","multiaddr":"^3.0.1","multihashes":"~0.4.9","once":"^1.4.0","path-exists":"^3.0.0","peer-book":"~0.5.1","peer-id":"~0.10.1","peer-info":"~0.11.0","prom-client":"^10.1.0","prometheus-gc-stats":"^0.5.0","promisify-es6":"^1.0.3","pull-file":"^1.0.0","pull-paramap":"^1.2.2","pull-pushable":"^2.1.1","pull-sort":"^1.0.1","pull-stream":"^3.6.1","pull-stream-to-stream":"^1.3.4","pull-zip":"^2.0.1","read-pkg-up":"^2.0.0","readable-stream":"2.3.3","safe-buffer":"^5.1.1","stream-to-pull-stream":"^1.7.2","tar-stream":"^1.5.4","temp":"~0.8.3","through2":"^2.0.3","update-notifier":"^2.2.0","yargs":"8.0.2"},"deprecated":false,"description":"JavaScript implementation of the IPFS specification","devDependencies":{"aegir":"^11.0.2","buffer-loader":"0.0.1","chai":"^4.1.2","delay":"^2.0.0","detect-node":"^2.0.3","dir-compare":"^1.4.0","dirty-chai":"^2.0.1","eslint-plugin-react":"^7.3.0","execa":"^0.8.0","expose-loader":"^0.7.3","form-data":"^2.3.1","gulp":"^3.9.1","interface-ipfs-core":"~0.31.19","ipfsd-ctl":"~0.23.0","left-pad":"^1.1.3","lodash":"^4.17.4","mocha":"^3.5.2","ncp":"^2.0.0","nexpect":"^0.5.0","pre-commit":"^1.2.2","pretty-bytes":"^4.0.2","qs":"^6.5.1","random-fs":"^1.0.3","rimraf":"^2.6.1","stream-to-promise":"^2.2.0","transform-loader":"^0.2.4"},"engines":{"node":">=6.0.0","npm":">=3.0.0"},"homepage":"https://github.com/ipfs/js-ipfs#readme","keywords":["IPFS"],"license":"MIT","main":"src/core/index.js","name":"ipfs","optionalDependencies":{"prom-client":"^10.1.0","prometheus-gc-stats":"^0.5.0"},"pre-commit":["lint","test"],"repository":{"type":"git","url":"git+https://github.com/ipfs/js-ipfs.git"},"scripts":{"build":"gulp build","coverage":"gulp coverage","coverage-publish":"aegir-coverage publish","lint":"aegir-lint","release":"gulp release","release-major":"gulp release --type major","release-minor":"gulp release --type minor","test":"gulp test --dom","test:benchmark":"echo \"Error: no benchmarks yet\" && exit 1","test:benchmark:browser":"echo \"Error: no benchmarks yet\" && exit 1","test:benchmark:node":"echo \"Error: no benchmarks yet\" && exit 1","test:benchmark:node:core":"echo \"Error: no benchmarks yet\" && exit 1","test:benchmark:node:http":"echo \"Error: no benchmarks yet\" && exit 1","test:browser":"npm run test:unit:browser","test:interop":"npm run test:interop:node","test:interop:browser":"mocha -t 60000 test/interop/browser.js","test:interop:node":"mocha -t 60000 test/interop/node.js","test:node":"npm run test:unit:node","test:unit:browser":"gulp test:browser","test:unit:node":"gulp test:node","test:unit:node:cli":"TEST=cli npm run test:unit:node","test:unit:node:core":"TEST=core npm run test:unit:node","test:unit:node:gateway":"TEST=gateway npm run test:unit:node","test:unit:node:http":"TEST=http npm run test:unit:node"},"version":"0.26.0"}

/***/ }),

/***/ 905:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(541)
}
var Component = __webpack_require__(88)(
  /* script */
  __webpack_require__(408),
  /* template */
  __webpack_require__(909),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2b524738",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 906:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(542)
}
var Component = __webpack_require__(88)(
  /* script */
  __webpack_require__(409),
  /* template */
  __webpack_require__(910),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 907:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(544)
}
var Component = __webpack_require__(88)(
  /* script */
  __webpack_require__(410),
  /* template */
  __webpack_require__(912),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-62299d19",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 908:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(543)
}
var Component = __webpack_require__(88)(
  /* script */
  __webpack_require__(411),
  /* template */
  __webpack_require__(911),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 909:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('TopNav'), _vm._v(" "), _c('NodeInfo'), _vm._v(" "), _c('div', {
    staticClass: "main-container-wrapper"
  }, [_c('div', {
    staticClass: "description text-center"
  }, [_c('h1', [_vm._v("IPFS Browser Stream Benchmarks")]), _vm._v(" "), _c('p', [_vm._v("A small utility to test ipfs's get streaming performance (especially for large files) and see some metrics.")]), _vm._v(" "), _c('p', [_vm._v(" Choose one of the preselected files below or test with a custom one.")]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.status === 'stopped') ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.startNode
    }
  }, [_vm._v("Start your node")]) : _vm._e()], 1), _vm._v(" "), _c('el-tabs', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "87 kB",
      "name": "first"
    }
  }, [_c('Stream', {
    attrs: {
      "peers": _vm.peers,
      "nodeStatus": _vm.status,
      "benchmarks": _vm.getBenchmarkByHash('QmTKZgRNwDNZwHtJSjCp6r5FYefzpULfy37JvMt9DwvXse/poster.jpg'),
      "hash": "QmTKZgRNwDNZwHtJSjCp6r5FYefzpULfy37JvMt9DwvXse/poster.jpg"
    },
    on: {
      "submit": _vm.getFile
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "1 MB",
      "name": "second"
    }
  }, [_c('Stream', {
    attrs: {
      "peers": _vm.peers,
      "nodeStatus": _vm.status,
      "benchmarks": _vm.getBenchmarkByHash('QmTca4A43f4kEvzTouvYTegtp6KobixRqweV12NrvwwtFP'),
      "hash": "QmTca4A43f4kEvzTouvYTegtp6KobixRqweV12NrvwwtFP"
    },
    on: {
      "submit": _vm.getFile
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "22 MB",
      "name": "third"
    }
  }, [_c('Stream', {
    attrs: {
      "peers": _vm.peers,
      "nodeStatus": _vm.status,
      "benchmarks": _vm.getBenchmarkByHash('QmTKZgRNwDNZwHtJSjCp6r5FYefzpULfy37JvMt9DwvXse/video.webm'),
      "hash": "QmTKZgRNwDNZwHtJSjCp6r5FYefzpULfy37JvMt9DwvXse/video.webm"
    },
    on: {
      "submit": _vm.getFile
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Using the official IPFS ("), _c('a', {
    attrs: {
      "href": "https://github.com/ipfs/js-ipfs",
      "target": "_blank"
    }
  }, [_vm._v("js-ipfs")]), _vm._v(") v0.26.0")])
}]}

/***/ }),

/***/ 910:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('div', [_c('div', {
    staticClass: "node-info"
  }, [_c('a', {
    staticClass: "close-node-info",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeNodeInfo($event)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-circle-cross"
  })]), _vm._v(" "), _c('div', {
    staticClass: "toggle-node"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.status != 'stopped',
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.startNode
    }
  }, [_vm._v("Start")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.status === 'stopped',
      "type": "danger",
      "size": "small"
    },
    on: {
      "click": _vm.stopNode
    }
  }, [_vm._v("Stop")]), _vm._v(" "), (_vm.status === 'starting') ? _c('el-button', {
    attrs: {
      "type": "simple",
      "loading": true,
      "size": "small"
    }
  }, [_vm._v("Starting")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "node-addresses"
  }, [_c('br'), _vm._v(" "), (_vm.status === 'running') ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.node.addresses
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Node Info"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_c('strong', [_vm._v("ID:")]), _vm._v(" "), _c('br'), _vm._v(_vm._s(_vm.node.id))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Address:")]), _c('br'), _vm._v(_vm._s(scope.row))])]
      }
    }])
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('h4', [_vm._v("Connected peers " + _vm._s(_vm.node.peers.length) + " "), _c('div', [_vm._v(_vm._s(_vm.peersStatus))])]), _vm._v(" "), _c('div', {
    staticClass: "node-peers"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.node.peers,
      "border": "",
      "empty-text": "No peers connected"
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "peer-address",
    attrs: {
      "prop": "addr",
      "label": "Address"
    }
  })], 1)], 1)])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "node-label"
  }, [_c('strong', [_vm._v("Ipfs Node")])])
}]}

/***/ }),

/***/ 911:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-menu', {
    staticClass: "el-menu-demo",
    attrs: {
      "mode": "horizontal"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "1"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/ipfs/js-ipfs",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "https://camo.githubusercontent.com/44d46e125f11fe293dde1e6c92760b1ad6253132/68747470733a2f2f697066732e696f2f697066732f516d566b37737272776168584c4e6d634459767955454a7074796f78706e646e52613537594a31314c346a5632362f697066732e6a732e706e67"
    }
  })])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "5"
    },
    on: {
      "click": _vm.openNodeInfo
    }
  }, [_c('el-button', {
    attrs: {
      "plain": true,
      "size": "small",
      "type": "info"
    }
  }, [_vm._v("info")])], 1), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "5"
    }
  }, [_vm._v(_vm._s(_vm.status))]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "6"
    }
  }, [_vm._v("Connected Peers: " + _vm._s(_vm.node.peers.length))]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "7"
    }
  }), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "8"
    }
  }, [(_vm.status === 'stopped') ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.startNode
    }
  }, [_vm._v("Start")]) : _vm._e(), _vm._v(" "), (_vm.status != 'stopped') ? _c('el-button', {
    attrs: {
      "type": "danger",
      "size": "small"
    },
    on: {
      "click": _vm.stopNode
    }
  }, [_vm._v("Stop")]) : _vm._e(), _vm._v(" "), (_vm.status === 'starting') ? _c('el-button', {
    attrs: {
      "type": "simple",
      "loading": true,
      "size": "small"
    }
  }, [_vm._v("Starting")]) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 912:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('br'), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.start(_vm.fileHash)
      }
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Hash",
      "value": _vm.hash
    },
    model: {
      value: (_vm.fileHash),
      callback: function($$v) {
        _vm.fileHash = $$v
      },
      expression: "fileHash"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [(!_vm.loading) ? _c('span', [_vm._v("Get")]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('i', {
    staticClass: "el-icon-loading"
  }) : _vm._e()])], 2)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.loading,
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        _vm.start(_vm.fileHash)
      }
    }
  }, [_vm._v(_vm._s(_vm.btnText))])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('el-progress', {
    attrs: {
      "percentage": parseInt(_vm.downloadPercentage())
    }
  }), _vm._v(" "), (_vm.benchmarks) ? _c('el-row', {
    attrs: {
      "gutter": 0
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v(" Elapsed: " + _vm._s((_vm.elapsed())))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_vm._v(" Received: " + _vm._s(_vm.downloadPercentage()) + "% (" + _vm._s(_vm.received()) + "/" + _vm._s(_vm.total()) + ")")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v(" Speed: " + _vm._s(_vm.rate()) + "/sec")])], 1) : _vm._e()], 1)])], 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.benchmarks && _vm.benchmarks.chunks.length > 0) ? _c('div', {
    staticClass: "chunks"
  }, [_c('h2', [_vm._v("Report")]), _vm._v(" "), _c('el-table', {
    staticClass: "report",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": [1],
      "stripe": "",
      "max-height": "500"
    }
  }, [_c('el-table-column', {
    attrs: {
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "metrics"
        }, [_c('div', [_vm._v("Hash ")]), _vm._v(" "), _c('div', [_vm._v("Total size")]), _vm._v(" "), _c('div', [_c('div', {
          staticStyle: {
            "visibility": "hidden"
          }
        }, [_vm._v(".")])]), _vm._v(" "), _c('div', [_vm._v("Received ")]), _vm._v(" "), _c('div', [_vm._v("Started ")]), _vm._v(" "), _c('div', [_vm._v("Finished ")]), _vm._v(" "), _c('div', [_vm._v("Duration ")]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Rates :")])]), _vm._v(" "), _c('div', [_vm._v("Min ")]), _vm._v(" "), _c('div', [_vm._v("Max ")]), _vm._v(" "), _c('div', [_vm._v("Average")]), _vm._v(" "), _c('div', [_vm._v("Median")])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "metrics"
        }, [_c('div', [_vm._v(_vm._s(_vm.benchmarks.hash))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.prettyBytes(_vm.benchmarks.totalBytes)))]), _vm._v(" "), _c('div', [_c('div', {
          staticStyle: {
            "visibility": "hidden"
          }
        }, [_vm._v(".")])]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.prettyBytes(_vm.benchmarks.received)))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(new Date(_vm.benchmarks.started).toString()))]), _vm._v(" "), (_vm.benchmarks.finished) ? _c('div', [_vm._v(_vm._s(new Date(_vm.benchmarks.finished).toString()))]) : _c('div', [_vm._v(" running")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.elapsed()) + " ")]), _vm._v(" "), _c('div', [_c('div', {
          staticStyle: {
            "visibility": "hidden"
          }
        }, [_vm._v(".")])]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.prettyBytes(_vm.benchmarks.rates.min)) + "/sec")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.prettyBytes(_vm.benchmarks.rates.max)) + "/sec")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.prettyBytes(_vm.benchmarks.rates.avg)) + "/sec")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.prettyBytes(_vm.benchmarks.rates.median)) + "/sec")])])]
      }
    }])
  })], 1), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.benchmarks.chunks.length) + " Chunks")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.benchmarks.chunks,
      "default-sort": {
        prop: 'time',
        order: 'ascending'
      },
      "stripe": "",
      "max-height": "500"
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "time",
      "label": "Arrived",
      "sortable": "",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v(_vm._s(new Date(scope.row.time).getHours()) + ":" + _vm._s(new Date(scope.row.time).getMinutes()) + ":" + _vm._s(new Date(scope.row.time).getSeconds()) + "." + _vm._s(new Date(scope.row.time).getMilliseconds()))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "bytes",
      "label": "Size",
      "sortable": "",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm.prettyBytes(scope.row.bytes)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "rate",
      "sortable": "",
      "label": "Speed"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.prettyBytes(scope.row.rate)) + " /sec")])]
      }
    }])
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('br'), _c('br')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 913:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 920:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 921:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 922:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 923:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 924:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 925:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 926:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 927:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 928:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 929:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 930:
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

},[402]);


// WEBPACK FOOTER //
// static/js/app.58bbcb0c80f710965d43.js